@use "@fukuri-admins/ui/layout" as *;

.SideMenuNavigation {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  @media screen and (max-width: $TB) {
    display: none;
  }

  &__List {
    margin: 0;
    padding: 0;
    width: 100%;
    border-top: 1px solid $NATURAL_200;
  }
}
